import { render, staticRenderFns } from "./ProductForm.vue?vue&type=template&id=27d86794&lang=pug&"
import script from "./ProductForm.vue?vue&type=script&lang=js&"
export * from "./ProductForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/boyoon/Desktop/Project/kl3/wonderapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27d86794')) {
      api.createRecord('27d86794', component.options)
    } else {
      api.reload('27d86794', component.options)
    }
    module.hot.accept("./ProductForm.vue?vue&type=template&id=27d86794&lang=pug&", function () {
      api.rerender('27d86794', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "scripts/vue-components/product/ProductForm.vue"
export default component.exports